import { Emit, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import type { IBriefingPage, IResourceModel } from '@/shared/model/briefing-widget.model';
import moment from 'moment';
import { namespace } from 'vuex-class';
import BriefingService from '@/service/briefing.service';
import { makeReportTypeText, onErrorImageAvatar } from '@/util/common-util';
import { convertDate, convertDateToYYYYMMDD, formatDateAgo } from '../../../../util/date-util';
import PopupDeleteBriefingComponent from '@/entities/briefing/popup-delete-briefing/popup-delete-briefing.vue';
import DiscoveryAndReportService from '@/service/discoveryAndReport.service';
import { map2ResourceItem } from '@/util/mapper-utils';
import { handleRemoveLocalStorageGoOverAgainData } from '@/util/localStorage-util';
import { formattedDate } from '@/entities/report-insights/report-common';
import { getRolePayloadForAPI } from '@/util/paid-user-util';
import UserMyPageService from '@/service/userMyPage.service';
import ConfirmAction from '@/v2/shared/modal/confirm-action/confirm-action.vue';
import OutOfActive from '@/v2/shared/modal/out-of-active/out-of-active.vue';
import { checkIsGuestAccount } from '@/util/guest-util';

const briefingStore = namespace('briefingStore');
const appStoreState = namespace('appStore');

@Component({
  methods: { convertDate, convertDateToYYYYMMDD, formattedDate, makeReportTypeText, formatDateAgo, onErrorImageAvatar },
  computed: {
    moment() {
      return moment;
    },
  },
  components: {
    popupDeleteBriefingComponent: PopupDeleteBriefingComponent,
    'confirm-action': ConfirmAction,
    'out-of-active': OutOfActive,
  },
})
export default class SocialBriefingCard extends Vue {
  @Prop(Object) readonly formModel: IBriefingPage;
  @Prop(Boolean) readonly isEditMode: boolean | false;
  @Prop(Boolean) readonly hideSettingMode: boolean;
  @Prop() readonly idSwitch: string;

  isCheckedDelete = false;
  tempUserKey = this.$store.getters?.userIdentity?.id || '';
  isOpenConfirmAction = false;
  isOutOfActive = false;
  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;
  isLoadingCheckActive = false;
  isLoading = false;
  tempDeleteObject: any = {};
  countTimesOnchange = 0;
  resourceItems: any[] | [];

  @Inject('briefingService')
  private briefingService: () => BriefingService;
  @Inject('userMyPageService')
  private userMyPageService: () => UserMyPageService;

  @briefingStore.Getter
  public getIsDoneHideSelectedResourceItem!: boolean;

  @briefingStore.Mutation
  public setIsDoneHideSelectedResourceItem!: (payload: any) => void;

  @briefingStore.Mutation
  public setSelectedHideResource!: (payload: any) => void;

  @briefingStore.Getter
  public getRemovingBriefingIds!: string[];

  @briefingStore.Mutation
  public setRemovingBriefingIds: (payload: string[]) => void;

  @briefingStore.Action
  public updatePinBriefing!: ({ bpId, isPin }: { bpId: string; isPin: boolean }) => Promise<void>;

  @briefingStore.Getter
  public getIsPinned!: boolean;

  @briefingStore.Getter
  public getBriefingPages!: IBriefingPage[];

  @briefingStore.Mutation
  public setIsPinInBriefingList: (payload: any) => void;

  @briefingStore.Mutation
  public setBriefingPages: (payload: any) => void;

  @briefingStore.Mutation
  public setSelectedUpdatingBriefingPage: (payload: any) => void;

  @briefingStore.Mutation
  public setDeleteBriefingPageInList!: (payload: any) => void;

  @briefingStore.Getter
  public getCheckCallApiMyBP!: boolean;

  @briefingStore.Mutation
  public setIsHideSelectedResourceItem!: (payload: any) => void;

  @briefingStore.Getter
  public getIsHideSelectedResourceItem!: boolean;

  @appStoreState.Mutation
  public setIsShowUpdateBriefing!: (isShowUpdateBriefing: boolean) => void;

  @appStoreState.Mutation
  public setIsShowDeleteBriefing!: (payload: any) => void;

  @appStoreState.Mutation
  public setIsDeleteSingleBriefing!: (payload: any) => void;

  @appStoreState.Mutation
  public setCurrentDeleteBriefingName!: (payload: any) => void;

  @appStoreState.Mutation
  public setNumberOfDeleteBriefings!: (payload: any) => void;

  @appStoreState.Mutation
  public setCurrentDeleteBriefingId!: (payload: any) => void;

  @appStoreState.Getter
  public getIsShowDeleteBriefing!: boolean;

  @appStoreState.Getter
  public getCurrentDeleteBriefingId!: string;

  @appStoreState.Mutation
  public setShowDetailArticles!: (b: boolean) => void;

  @appStoreState.Mutation
  public setShowDetailReport!: (b: boolean) => void;

  @briefingStore.Mutation
  public setSelectedResource!: (payload: IResourceModel) => void;

  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;

  @appStoreState.Mutation
  public setIsLoadingDeleteBriefing!: (payload: any) => void;

  @appStoreState.Mutation
  public setShowDetailTopic!: (b: boolean) => void;

  @Emit('toggle-subscribe') toggleSubscribe() {
    if (this.formModel.bpType === 'MY_BRIEFING') {
      this.checkActiveBf();
    }
  }

  @Emit('select') select(item: IResourceModel) {}

  @Emit('select-user-social') selectUserSocial(userKey: string) {
    return userKey;
  }

  @Inject('discoveryService')
  public discoveryService: () => DiscoveryAndReportService;

  isItemIndepthDaily(item) {
    return item?.parentDocDetail?.media_type?.includes('INDEPTH_DAILY');
  }

  onHandleOpenModal(item: any) {
    console.log(item);
    this.discoveryService()
      .checkDocumentTypeForUserKey(this.$store?.getters?.userIdentity.id, item.parentDocDetail?.parent_doc_id[0])
      .then(ref => {
        if (ref?.data?.body) {
          this.setSelectedResource({
            ...map2ResourceItem(item),
            isBookmarked: ref.data.body?.is_bookmarked,
          });
          const language = this.$store.getters.currentLanguage ? this.$store.getters.currentLanguage : '';
          switch (item.documentType) {
            case 'REPORT':
              this.setShowDetailReport(true);
              this.userMyPageService().saveUserActivitiesOpenReportDetail(item.parentDocDetail?.parent_doc_id[0], language);
              break;
            default:
              if (item.parentDocDetail?.media_type[0] === 'REPORT' || item.originParentDocDetail?.media_type[0] === 'REPORT') {
                this.setShowDetailReport(true);
                this.userMyPageService().saveUserActivitiesOpenReportDetail(item.parentDocDetail?.parent_doc_id[0], language);
                break;
              }

              this.setShowDetailArticles(true);
              break;
          }
        }
      });
  }

  mounted() {
    this.tempUserKey = this.$store.getters?.userIdentity?.id || '';
    this.resourceItems = this.filteredAndSortedItems(this.formModel?.listDocumentFeatured || []);
  }

  get truncatedUserName() {
    const numberOfStringToShow = 5;
    if (!this.formModel?.userProfile?.lastName) {
      return '';
    }
    const name = this.formModel.userProfile.lastName;
    return name.length >= numberOfStringToShow ? `${name.substring(0, numberOfStringToShow)}...` : name;
  }

  get dataSource() {
    if (this.formModel.bpType === 'MY_BRIEFING' && this.formModel.isActive === 0) {
      return true;
    }
    return false;
  }

  @Watch('getRemovingBriefingIds')
  onGetRemovingBriefingIdsChange() {
    if (!this.getRemovingBriefingIds || (this.getRemovingBriefingIds && this.getRemovingBriefingIds.length === 0)) {
      this.isCheckedDelete = false;
    } else if (this.getRemovingBriefingIds && this.getRemovingBriefingIds.length > 0 && this.formModel && this.formModel.bpId) {
      if (this.getRemovingBriefingIds.includes(this.formModel.bpId)) {
        this.isCheckedDelete = true;
      }
    }
  }

  @Watch('getIsHideSelectedResourceItem')
  onGetIsHideSelectedResourceItemChange() {
    if (
      this.getIsHideSelectedResourceItem === true &&
      this.getSelectedResource &&
      this.getSelectedResource._id &&
      this.getSelectedResource.docId &&
      this.resourceItems &&
      this.resourceItems.length > 0 &&
      !this.checkDuplicatedDelete(this.getSelectedResource) &&
      this.isLoading === false &&
      this.countTimesOnchange === 0
    ) {
      const tempResource: any = this.resourceItems;

      let tempIndex = tempResource.findIndex(i => i._id === this.getSelectedResource._id && i.docId === this.getSelectedResource.docId);

      if (tempIndex === -1) {
        tempIndex = tempResource.findIndex(i => i._id === this.getSelectedResource._id || i.docId === this.getSelectedResource.docId);
      }

      try {
        if (tempIndex !== -1) {
          ++this.countTimesOnchange;
          this.hide(this.getSelectedResource, tempIndex);
        } else {
          if (this.$route.name !== 'Home') {
            this.setSelectedHideResource(this.getSelectedResource);

            if (this.getIsDoneHideSelectedResourceItem === false) {
              this.setIsDoneHideSelectedResourceItem(!this.getIsDoneHideSelectedResourceItem);
            } else {
              this.setIsDoneHideSelectedResourceItem(true);
            }
          }
        }
      } catch (e) {
        this.setIsHideSelectedResourceItem(false);
      }
    }
  }

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  filteredAndSortedItems(arr) {
    try {
      //sort report and discovery
      return arr
        .filter(item => item.documentType.some(type => ['report', 'discovery'].includes(type.toLowerCase())))
        .sort((a, b) => {
          const aType = a.documentType[0].toLowerCase();
          const bType = b.documentType[0].toLowerCase();
          if (aType === 'report' && bType !== 'report') return -1;
          if (aType !== 'report' && bType === 'report') return 1;
          return 0;
        })
        .slice(0, 2);
    } catch (err) {
      return arr;
    }
  }

  toggleCheckedDelete() {
    this.isCheckedDelete = !this.isCheckedDelete;
    const removingIds = this.isCheckedDelete
      ? [...this.getRemovingBriefingIds, this.formModel.bpId]
      : this.getRemovingBriefingIds.filter(el => el !== this.formModel.bpId);
    this.setRemovingBriefingIds(removingIds);
  }

  onImageError(event) {
    event.target.style.position = 'relative';
    event.target.style.left = '0px';
    event.target.style.top = '0px';
    event.target.style.objectFit = 'cover';
    event.target.src = 'content/images/images_v3/common/go-empty-thumb-sz288.png';
  }

  async handlePinBriefing(bpId, isPin, formModel) {
    await this.updatePinBriefing({ bpId, isPin });
    this.setIsPinInBriefingList({ bpId: bpId, isPin: isPin });
  }

  handleDeleteBriefingPage() {
    if (this.tempUserKey && this.getCurrentDeleteBriefingId) {
      this.setIsLoadingDeleteBriefing(true);
      this.briefingService()
        .callAPIDeleteListBriefingPage(this.tempUserKey, [this.getCurrentDeleteBriefingId])
        .then(res => {
          if (res?.data?.body?.body?.length > 0) {
            handleRemoveLocalStorageGoOverAgainData([this.getCurrentDeleteBriefingId]);

            this.setDeleteBriefingPageInList({ isDelete: true, length: this.getBriefingPages.length });

            this.setBriefingPages(this.getBriefingPages.filter(e => e.bpId !== this.getCurrentDeleteBriefingId));

            this.resetAfterDeleteBriefing();

            this.$nextTick(() => {
              this.showResponseMessage(`${this.$t('toast.delete.success')}`, `${this.$t('toast.title.success')}`, 'success', 5000);
            });
          } else {
            // this.showResponseMessage('Delete Briefing Fail!', 'Error', 'danger', 5000);
            this.showResponseMessage(`${this.$t('toast.delete.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);
          }
        })
        .catch(e => {
          this.setIsLoadingDeleteBriefing(false);
          // this.showResponseMessage('Delete Briefing Fail!', 'Error', 'danger', 5000);
          this.showResponseMessage(`${this.$t('toast.delete.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);
        });
    }
  }

  handleOpenModalUpdateBriefingPage() {
    if (this.formModel) {
      this.setSelectedUpdatingBriefingPage(this.formModel);
      this.setIsShowUpdateBriefing(true);
    }
  }

  showResponseMessage(mess, title, variant, hideDelay) {
    this.$bvToast.toast(mess, {
      toaster: 'b-toaster-bottom-right',
      title: title,
      variant: variant,
      solid: true,
      autoHideDelay: hideDelay,
    });
  }

  formatDateString(input) {
    try {
      const date = new Date(input);
      if (isNaN(date.getTime())) {
        return '';
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } catch (e) {
      return '';
    }
  }

  handleOpenDeleteBriefingModal() {
    this.setIsShowDeleteBriefing(true);
    this.setIsDeleteSingleBriefing(true);
    this.setCurrentDeleteBriefingId(this.formModel?.bpId ? this.formModel.bpId : '');
    this.setCurrentDeleteBriefingName(this.formModel?.briefingPageName ? this.formModel.briefingPageName : '');
  }

  resetAfterDeleteBriefing() {
    this.setIsShowDeleteBriefing(false);
    this.setCurrentDeleteBriefingName('');
    this.setNumberOfDeleteBriefings(0);
    this.setCurrentDeleteBriefingId('');
    this.setIsLoadingDeleteBriefing(false);
    this.$emit('handleDeleteBriefings');
  }

  openConfirm() {
    this.isOpenConfirmAction = true;
  }

  checkActiveBf() {
    if (!this.formModel.isActive) {
      this.isLoadingCheckActive = true;
      this.briefingService()
        .getAllActiveBriefingOrScrap(7)
        .then(res => {
          this.isLoadingCheckActive = false;
          const totalBf = this.localStorageUser?.policyUsers?.find(item => item.featureIdx === 7)?.total;
          if (+res?.data >= +totalBf) {
            this.isOutOfActive = true;
          } else {
            this.activeBriefingPage(this.formModel);
          }
        })
        .catch(e => (this.isLoadingCheckActive = false));
    } else {
      this.activeBriefingPage(this.formModel);
    }
  }

  activeBriefingPage(item: IBriefingPage) {
    const rolePayload = getRolePayloadForAPI();
    const toggleActive = item.isActive === 0 ? 1 : 0;
    if (this.tempUserKey) {
      this.briefingService()
        .activeBriefingPage(item.bpId, this.tempUserKey, toggleActive, rolePayload)
        .then(r => {
          const updatedPages = [...this.getBriefingPages];
          const itemIndex = updatedPages.findIndex(page => page.bpId === item.bpId);

          if (itemIndex !== -1) {
            updatedPages[itemIndex] = {
              ...updatedPages[itemIndex],
              isActive: toggleActive,
            };
            this.setBriefingPages(updatedPages);
            this.isOpenConfirmAction = false;
          }
        })
        .catch(e => {
          console.error('Some thing wrong update briefing page: ', e);
        });
    }
  }

  checkDuplicatedDelete(itemInput: any) {
    if (this.isLoading === true) {
      return true;
    }

    return itemInput && this.tempDeleteObject?.id === itemInput._id && this.tempDeleteObject?.docId === itemInput.docId;
  }

  hide(item: IResourceModel, index: number) {
    if (checkIsGuestAccount(true)) {
      return;
    }

    if (item) {
      switch (item.originParentDocDetail?.doc_type) {
        case 1:
          item.type = 'REFERENCE';
          break;
        case 2:
          item.type = 'DISCOVERY';
          break;
        case 3:
          item.type = 'RESOURCE';
          break;
        case 4:
          item.type = 'REPORT';
          break;
        case 5:
          item.type = 'ASK_GOOVER';
          break;
        case 6:
          item.type = 'PEOPLE';
          break;
        case 7:
          item.type = 'COMPANY';
          break;
        case 8:
          item.type = 'TOPIC_SUMMARY';
          break;
        default:
          break;
      }
    } else {
      this.isLoading = false;
      return;
    }

    if (!item.type) {
      this.isLoading = false;
      return;
    }

    if (this.$route.name !== 'Home') {
      this.setSelectedHideResource(item);
    }

    if (item.type !== 'REFERENCE') {
      if (this.$route.name !== 'Home') {
        if (!this.checkDuplicatedDelete(item)) {
          const tempDeleteObject = { id: item._id ? item._id : '', docId: item.docId ? item.docId : '' };
          this.isLoading = true;

          this.briefingService()
            .feedUpdateStatus({
              id: item._id ? item._id : '',
              briefingPageId: item.bpId
                ? item.bpId
                : item.originParentDocDetail?.briefing_page_id
                ? item.originParentDocDetail.briefing_page_id[0]
                : '',
              parentDocId: item.docId ? item.docId : '',
              typeDocument: item.type ? item.type : '',
              isDeleted: true,
            })
            .then(response => {
              if (response?.data?.body?.body && response?.data?.body?.status === 1 && response?.data?.body?.success === true) {
                if (index !== -1) {
                  this.resourceItems.splice(index, 1);
                }

                if (this.getIsDoneHideSelectedResourceItem === false) {
                  this.setIsDoneHideSelectedResourceItem(!this.getIsDoneHideSelectedResourceItem);
                } else {
                  this.setIsDoneHideSelectedResourceItem(true);
                }

                // @ts-ignore
                this.setSelectedResource({});
                this.setShowDetailArticles(false);
                this.setShowDetailReport(false);
                this.setShowDetailTopic(false);
              } else {
                this.tempDeleteObject = {};
              }
            })
            .catch(e => {
              this.setIsHideSelectedResourceItem(false);
              this.tempDeleteObject = {};
            })
            .finally(() => {
              setTimeout(() => {
                this.setIsHideSelectedResourceItem(false);
                this.isLoading = false;
                this.countTimesOnchange = 0;
              }, 10);
            });
        }
      } else {
        if (!this.checkDuplicatedDelete(item)) {
          this.tempDeleteObject = { id: item._id ? item._id : '', docId: item.docId ? item.docId : '' };
          this.isLoading = true;

          if (item.isNew) {
            // Hide in view (not call api)
            this.resourceItems.splice(index, 1);
            return;
          }

          this.briefingService()
            .callAPIHideCardInHome({
              id: item._id ? item._id : '',
              similar_hash: item.originParentDocDetail?.similar_hash ? item.originParentDocDetail?.similar_hash : '',
              userKey:
                this.userIdentity?.id || this.$store.getters?.account?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || '',
              briefingPageId: item.bpId
                ? item.bpId
                : item.originParentDocDetail?.briefing_page_id
                ? item.originParentDocDetail.briefing_page_id[0]
                : '',
              parentDocId: item.docId ? item.docId : '',
              isLiked: true,
              isBookmarked: item.isBookmarked ? true : false,
              isDeleted: true,
              typeDocument: item.type ? item.type : '',
            })
            .then(response => {
              if (response?.data?.body?.body && response?.data?.body?.status === 1 && response?.data?.body?.success === true) {
                if (index !== -1) {
                  this.resourceItems.splice(index, 1);
                }

                if (this.getIsDoneHideSelectedResourceItem === false) {
                  this.setIsDoneHideSelectedResourceItem(!this.getIsDoneHideSelectedResourceItem);
                } else {
                  this.setIsDoneHideSelectedResourceItem(true);
                }

                // @ts-ignore
                this.setSelectedResource({});
                this.setShowDetailArticles(false);
                this.setShowDetailReport(false);
                this.setShowDetailTopic(false);
              } else {
                this.tempDeleteObject = {};
              }
            })
            .catch(e => {
              this.setIsHideSelectedResourceItem(false);
              this.tempDeleteObject = {};
            })
            .finally(() => {
              setTimeout(() => {
                this.setIsHideSelectedResourceItem(false);
                this.isLoading = false;
                this.countTimesOnchange = 0;
              }, 10);
            });
        }
      }
    }
  }

  handleClick() {
    if (this.isEditMode) {
      this.toggleCheckedDelete();
    }
  }
}
